import { render } from "./LocationDevice.vue?vue&type=template&id=6e32e3b0&ts=true"
import script from "./LocationDevice.vue?vue&type=script&lang=ts"
export * from "./LocationDevice.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__